import React from 'react';
import './AppAds.css';

function AppAds() {
  return (
    <div className="app-ads-container">
      <pre className="app-ads-content">
        google.com, pub-4707421386156125, DIRECT, f08c47fec0942fa0
      </pre>
    </div>
  );
}

export default AppAds;
